






















































































































































































































































import Vue from "vue";
import Component from "vue-class-component";
import { Inject, Watch } from "vue-property-decorator";
import { RestClient } from "@elite/restclient";
import { DefaultGridOptions, AjaxDataSource, initializeTable } from "../table";
import { GridOptions } from "ag-grid-community";
import { DashboardGridModel } from "../models";
import moment from "moment";

@Component
export default class DashboardGrid extends Vue {
    @Inject()
    restClient!: RestClient;

    gridOptions: GridOptions = new DefaultGridOptions(
        undefined,
        false,
        false,
        false
    );

    // Default current dates to today
    fromDate: string = moment()
        .startOf("day")
        .format(moment.HTML5_FMT.DATETIME_LOCAL_SECONDS);
    toDate: string = moment()
        .endOf("day")
        .format(moment.HTML5_FMT.DATETIME_LOCAL_SECONDS);

    promoCodeMode = false;

    get excelReportUrl(): string {
        const apiUrl: string = process.env.VUE_APP_API_BASE_URL;
        const token = this.$store.state.token;
        return `${apiUrl}api/DashboardGrid/Export?fromOrderDate=${this.fromDate}&toOrderDate=${this.toDate}&promoCodeMode=${this.promoCodeMode}&token=${token}`;
    }

    @Watch("promoCodeMode")
    promoCodeModeChanged() {
        if (this.gridOptions.columnApi) {
            // Set promo-code column visible
            this.gridOptions.columnApi.setColumnVisible(
                "promoCode",
                this.promoCodeMode
            );

            this.gridOptions.columnApi.setColumnVisible(
                "promotionName",
                this.promoCodeMode
            );
        }

        if (this.gridOptions.api) {
            // Refresh grid, since new data is populated based on the source code column.
            this.gridOptions.api.setDatasource(this.dataSource);
            this.gridOptions.api.sizeColumnsToFit();
        }
    }

    dataSource!: AjaxDataSource<DashboardGridModel>;

    additionalData(): Record<string, string> {
        return {
            fromOrderDate: this.fromDate,
            toOrderDate: this.toDate,
            promoCodeMode: this.promoCodeMode.toString()
        };
    }

    mounted() {
        this.dataSource = new AjaxDataSource<DashboardGridModel>(
            this.restClient,
            "/api/DashboardGrid",
            this.additionalData,
            this.gridOptions.api
        );
        initializeTable(
            this.gridOptions,
            this.dataSource,
            undefined,
            this,
            true
        );
    }

    search(fromDate: string, toDate: string) {
        this.fromDate = fromDate;
        this.toDate = toDate;

        if (this.gridOptions.api) {
            this.gridOptions.api.setDatasource(this.dataSource);
        }
    }
}
